import React, {useRef, useEffect, useState} from 'react'
import useWindowSize from 'src/shared/service/use_window_size.jsx'
import {Hotspot} from "./hotspot";
import {useSelector} from "react-redux";
import useScrollbarVisibility from 'src/shared/service/use_scrollbar_visibility'
import {orderBy} from "lodash";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import VirtualCongressBackground from './virtual_congress_background'
import useInterval from '@use-it/interval'
import classNames from 'classnames'
import VideoLooper from "./video_looper";

export default function ImageMapBackgroundVideo({imageMap}) {
  const background_video_start_until_seconds = imageMap?.config_data?.background_video_start_until_seconds
  const background_video_loop_until_seconds = imageMap?.config_data?.background_video_loop_until_seconds

  if (imageMap.render_mode !== "video" && !imageMap.background_video_url) {
    return null
  }

  if (background_video_start_until_seconds || background_video_loop_until_seconds) {
    return <VideoLooper
      videoUrl={imageMap.background_video_url}
      introStart={0}
      introEnd={background_video_start_until_seconds}
      loopStart={background_video_start_until_seconds}
      loopEnd={background_video_loop_until_seconds}
      outroStart={background_video_loop_until_seconds}
    />
  } else {
    return <>
      <style>
        {`
                  *::-webkit-media-controls-panel {
                    display: none!important;
                    -webkit-appearance: none;
                  }
                  /* Old shadow dom */

                  *::--webkit-media-controls-play-button {
                    display: none!important;
                    -webkit-appearance: none;
                  }
                  /* New shadow dom */

                  *::-webkit-media-controls-start-playback-button {
                    display: none!important;
                    -webkit-appearance: none
                  }
                `}
      </style>
      <video style={{width: "100%", position: "absolute"}} loop autoPlay muted>
        <source src={imageMap.background_video_url} type="video/mp4"/>
      </video>
    </>;
  }
}
